export default __webpack_public_path__ + "static/media/3.0f3fdaa9.webm";